<div class="in-play-container">
  <div class="sport-tabs">
    @for (item of navItems; track item) {
      <a class="sport-tab-link" 
         [routerLink]="item?.path" 
         routerLinkActive="active" 
         #rla="routerLinkActive" 
         [class.active]="rla?.isActive">
        {{ item.label | translate }}
      </a>
    }
  </div>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
